import "../../../styles/hubweb/hubProductView.scss";
import "../../../styles/page/shoppingCart.scss";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";

export class HubCustomerListHeader extends React.PureComponent {
    render() {
        const {
            localization,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <div className="container">
                    <div className="list" style={{ display: "flex"}} >
                        <div style={{ flexBasis: "22%"}}>
                            <ResponsiveRows gutters={false} >
                                <ResponsiveColumn lg={4}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("hub", "production", "departmentStoreNo")}
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={8}>
                                    <div className="product-view-list-header" style={{ textIndent: "0px" }}>
                                        {localization.text("hub", "production", "customerName")}
                                    </div>
                                </ResponsiveColumn>                                
                            </ResponsiveRows>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HubCustomerListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
};

class HubCustomerListItem extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            customer,
            style,
        } = this.props;

        return (
            <div className="product-view-list-item-wrapper not-interactive" style={style}>
                <div className="container">
                    <div className="list" style={{ display: "flex"}} >
                        <div style={{ flexBasis: "22%"}}>
                            <ResponsiveRows gutters={false}>
                                <ResponsiveColumn lg={4}>
                                    <div className="label14 product-view-list-item-prd-info_multiline_narrow" style={{ display: "flex", alignItems: "center"}}>
                                        <div style={{ width: "100%" }}>
                                            {customer.departmentStoreNo}
                                        </div>
                                    </div>
                                </ResponsiveColumn>
                                <ResponsiveColumn lg={8}>
                                    <div className="label14 product-view-list-item">
                                        <div style={{ width: "100%" }}>
                                            {customer.customerName}
                                        </div>
                                    </div>
                                </ResponsiveColumn>               
                            </ResponsiveRows>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
HubCustomerListItem.propTypes = {
    customer: PropTypes.object,
    style: PropTypes.object,
};



class HubCustomerSortingList extends React.PureComponent {
    constructor(props) {
        super(props);
        this.createDraggableCustomers = this.createDraggableCustomers.bind(this);
        this.prepareDraggableItems = this.prepareDraggableItems.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
    }

    onDragEnd(result) {
        const {
            updateHubCustomerSortOrder,
            dateIndex,
            thisWeek,
        } = this.props;

        // dropped outside the list
        if (!result.destination) {
            return;
        }

        //swap places
        updateHubCustomerSortOrder(result.source.index, result.destination.index, dateIndex, thisWeek);
    }

    prepareDraggableItems() {
        const drag = (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{width:"100%"}}
                        >
                            {
                                this.createDraggableCustomers()
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>);
        return drag;
    }

    createDraggableCustomers() {
        const {
            customers,
        } = this.props;

        const retNodes = [];

        for (let i = 0; i < customers.length; i++) {
            const customerId = customers[i].customerId;

            retNodes[retNodes.length] = (
                <Draggable key={`Un-${customerId}`} draggableId={`Un-${customerId}`} index={i}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <HubCustomerListItem
                                style={{backgroundColor: snapshot.isDragging?"#e8e9eb":"#f6f7f8"}}
                                customer={customers[i]}
                            />
                        </div>
                    )}
                </Draggable>
            );
        }
        return retNodes;
    }


    render() {
        const {
            localization,
            height,
        } = this.props;

        const nodes = this.prepareDraggableItems();

        return (
            <React.Fragment>
                <div className={"hub-product-view-header-wrapper"} >
                    <HubCustomerListHeader localization={localization} />
                </div>
                <div className={"hub-product-view-items-wrapper"} style={{overflowY: "auto", height: height-45}}>
                    {nodes}
                </div>
            </React.Fragment>
           
        );
    }
}
HubCustomerSortingList.propTypes = {
    localization: Localization.propTypes.isRequired,
    customers: PropTypes.array.isRequired,
    updateHubCustomerSortOrder: PropTypes.func.isRequired,
    dateIndex: PropTypes.number.isRequired,
    thisWeek: PropTypes.bool.isRequired,
    height: PropTypes.number,
};

export default HubCustomerSortingList;